import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { CircularProgress, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

interface Ticket {
    ticketTitle: string,
    ticketNumber: string,
    ticketDescription: string
    ticketPrice: string,
    imageUrl: string,
    shopName: string,
    slotNumber: string,
    status: string,
    addedBy: string,
    startDate: string,
    closeDate: string,
};

const ticketIntialData = {
    ticketTitle: "",
    ticketNumber:"",
    ticketDescription: "",
    ticketPrice: "",
    imageUrl: "",
    shopName: "",
    slotNumber: "",
    status: "",
    addedBy: "",
    startDate: "",
    closeDate: "",
}

const ViewTicket: React.FC = () => {

   //@ts-ignore
   const config = window.config;
   const apiBaseURL = config?.server || 'http://18.217.95.31:8080';
   const { t } = useTranslation('translation');
   const [ticket, setTicket] = useState<Ticket>(ticketIntialData);
   const [imageLoading, setImageLoading] = useState(false);
   const { id } = useParams();

   useEffect(()=>{
    getParticularTicketDetails();
   },[]);

   const getParticularTicketDetails = () => {
    axios.get(`${apiBaseURL}/api/ticket/fetchParticularTicketDetail?id=${id}`).then((data: any) => {
    if(data?.status == 200){
        let ticketData = data?.data?.ticket;
        setTicket({
            ticketTitle: ticketData?.ticketTitle,
            ticketNumber: ticketData?.ticketNumber,
            ticketDescription: ticketData?.ticketDescription,
            ticketPrice: ticketData?.ticketPrice,
            imageUrl: ticketData?.imageUrl,
            shopName: ticketData?.shopName,
            slotNumber: ticketData?.slotNumber,
            status: ticketData?.status,
            addedBy: ticketData?.addedBy,
            startDate: ticketData?.startDate,
            closeDate: ticketData?.closeDate,
        });
    }
    }).catch((err: any) => {
        console.log("err", err)
    }).finally(() => {
    })
   }

   const onLoad = () => {
    setImageLoading(false);
  };
  return (
   <Grid className='h-screen bg-white p-[2%] relative font-["Baloo-2"]'>
            <Grid>
                <Grid className='text-[#daa520]'>{t('ticketInformation')}</Grid>
                <Grid className='grid grid-cols-2 mt-1 gap-12'>
                    <Grid className='col-span-1'>
                        <Grid className='grid grid-cols-2 gap-x-16 my-2'>
                            <Grid className='col-span-1 font-[600]'>{t('title')}</Grid>
                            <Grid>{ticket?.ticketTitle}</Grid>
                        </Grid>
                        <Grid className='grid grid-cols-2 gap-x-16 my-2'>
                            <Grid className='col-span-1 font-[600]'>{t('number')}</Grid>
                            <Grid>{ticket?.ticketNumber}</Grid>
                        </Grid>
                        <Grid className='grid grid-cols-2 gap-x-16 my-2'>
                            <Grid className='col-span-1 font-[600]'>{t('descrition')}</Grid>
                            <Grid>{ticket?.ticketDescription}</Grid>
                        </Grid>
                        <Grid className='grid grid-cols-2 gap-x-16 my-2'>
                            <Grid className='col-span-1 font-[600]'>{t('viewPrice')}</Grid>
                            <Grid>{ticket?.ticketPrice}</Grid>
                        </Grid>
                        <Grid className={ticket?.imageUrl ? "my-2" : "grid grid-cols-2 gap-x-16 my-2"}>
                            <Grid className='col-span-1 font-[600]'>{t('image')}</Grid>
                            <Grid
                                item
                                xs={6}
                                className={ticket?.imageUrl ? 'h-[340px] w-1/2' : ''}
                            >
                            {ticket?.imageUrl ?
                                <img
                                    src={ticket?.imageUrl}
                                    onLoad={onLoad}
                                    className='w-full aspect-square object-cover rounded-[5%] mt-2'
                                /> : (imageLoading ? "" : "-")
                            }
                            </Grid>
                            <Grid>
                            {imageLoading && (
                                <CircularProgress
                                    color='inherit'
                                    size={14}
                                    thickness={6}
                                    style={{ marginLeft: "10%" }}
                                />
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid className='col-span-1'>
                        <Grid className='grid grid-cols-2 gap-x-16 my-2'>
                            <Grid className='col-span-1 font-[600]'>{t('startDate')}</Grid>
                            <Grid>{ticket?.startDate}</Grid>
                        </Grid>
                         <Grid className='grid grid-cols-2 gap-x-16 my-2'>
                            <Grid className='col-span-1 font-[600]'>{t('closeDate')}</Grid>
                            <Grid>{ticket?.closeDate}</Grid>
                        </Grid>
                        <Grid className='grid grid-cols-2 gap-x-16 my-2'>
                            <Grid className='col-span-1 font-[600]'>{t('status')}</Grid>
                            <Grid>{ticket?.status}</Grid>
                        </Grid>
                        <Grid className='grid grid-cols-2 gap-x-16 my-2'>
                            <Grid className='col-span-1 font-[600]'>{t('addedBy')}</Grid>
                            <Grid>{ticket?.addedBy}</Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
  )
}

export default ViewTicket;